export default __webpack_public_path__ + "static/tape-8608ab6141501d77933f8ef973c91f0a.png";